import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as dashboardActions from './../../actions/dashboardActions';
import * as commonActions from './../../actions/commonActions';
import * as activityActions from './../../actions/activityActions';
import styles from './LayoutComponent.less';
import { Responsive, WidthProvider as widthProvider } from 'react-grid-layout';
const ResponsiveReactGridLayout = widthProvider(Responsive);
import Modal from 'react-modal';
import {Button} from 'react-bootstrap';
import i18next from 'i18next';
import { applyStyle, applyClickActive, applyToHover,setDirection } from './../../utils/utils';
import MUIIcon from '../../components/IconMaterialUI/MUIIcon';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';
@connect(state => ({
    tempList: state.dashboardRoot.dashboardReducer.tempList,
    enableflag:state.dashboardRoot.dashboardReducer.enableflag,
    layoutModal: state.dashboardRoot.dashboardReducer.layoutModal,
    // selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
    trdkey:state.dashboardRoot.dashboardReducer.trdkey,
    selectedLang:state.dashboardRoot.commonReducer.selectedLang,
    language:state.dashboardRoot.commonReducer.language
}), {
  ...dashboardActions, ...commonActions, ...activityActions
})
export default class LayoutComponent extends Component {
  constructor(props){
    super(props);
    this.afterOpenModal = this.afterOpenModal.bind(this);
  }
  static propTypes = {
    tempList: PropTypes.array,
    loadTemplate: PropTypes.func,
    enableflag:PropTypes.bool,
    layoutModal:PropTypes.bool,
    setLayoutFlag:PropTypes.func,
    resizeInstrumentList:PropTypes.func.isRequired,
    resizeMargin:PropTypes.func.isRequired,
    resizeTradePanel:PropTypes.func.isRequired,
    resizeTradebook:PropTypes.func.isRequired,
    resizeChart:PropTypes.func.isRequired,
    setRefreshFlag:PropTypes.func,
    orderRefreshFlag:PropTypes.func
  }
  state = {
    templatelist: [],
    //setDefaultlayoutModal:false,
    deletelayoutModal:false,
  }
  componentDidMount(){
    this.props.getTempList();
    const lengthTempData = this.props.tempList.length;
    const templist = [];
    for (let index = 0; index < lengthTempData; index++) {
      templist.push(this.props.tempList[index]);
    }
    this.setState({templatelist: templist});
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.tempList !== this.state.templatelist){
      let templist = [];;
      for (let index = 0; index <  nextProps.tempList.length; index++) {
        templist.push(nextProps.tempList[index]);
      }
      this.setState({templatelist: templist});
    }
  }

  loadTemplate=(tmplData)=>{
    try{
      console.log("load template ");
      this.props.setRefreshFlag(false);
      this.props.orderRefreshFlag(false);
      this.props.setTooltipFlag(true);
      this.props.loadTemplate(tmplData);
      this.props.navigationTradeReport('trade');
      let loadSavedTemp = JSON.parse(tmplData);
      loadSavedTemp.tmplData.map((item) => {
        let str = item.i;
        str = str.substring(0, str.indexOf('-'));
        switch (str) {
          case 'Instrument':
            this.props.resizeInstrumentList(item.h,item.w);
            break;
          case 'Margin':
            this.props.resizeMargin(item.h,item.w);
            break;
          case 'Trade':
            item.name = 'Trade';
            if(item.i == this.props.trdkey){
              this.props.resizeTradePanel(item.h,item.w);
            }else{
              this.props.resizeTradePanel(item.h,item.w);
            }
            break;
          case 'TradeActivityBook':
            this.props.resizeTradebook(item.h,item.w);
            break;
          case 'Chart':
            this.props.resizeChart(item.h,item.w);
            break;
          default:
            break;
        }
      });
      this.props.setLayoutFlag(false);
      //this.props.addwidgetflag(true)
      if(this.props.navigationTradeReport('trade')){
        this.props.layoutflag(false);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'loadTemplate', component:"LayoutComponent"});
    }
  }
  // setAsDefault=(tempid,tmpl,tempName)=>{
  //   const layout = JSON.parse(tmpl);
  //   //for update layout mode=E
  //   this.props.saveTemplate(layout.tmplData, layout.tradeBookData,tempName,tempid ,1, "E").then(
  //             response => {
  //               this.props.getTempList();
  //             }
  //           )
  //   this.setState({setDefaultlayoutModal: false});
  //   this.props.getTempList();
  // }

  setDefaultlayoutModal=(tempid,tempDes,tempName)=>{
    try{
      this.props.setRefreshFlag(false);
      this.props.orderRefreshFlag(false);
      const layout = JSON.parse(tempDes);
      this.setState({tempid: tempid});
      this.setState({tempDesc: tempDes});
      this.setState({tempName: tempName});
      //this.setState({setDefaultlayoutModal: true});
      this.props.saveTemplate(layout.tmplData, layout.tradeBookData,tempName,tempid ,1, "E").then(
                response => {
                  this.props.getTempList();
                }
              )
      this.props.getTempList();
      this.props.loadTemplate(tempDes);
      let loadSavedTemp = JSON.parse(tempDes);
      loadSavedTemp.tmplData.map((item) => {
        let str = item.i;
        str = str.substring(0, str.indexOf('-'));
        switch (str) {
          case 'Instrument':
            this.props.resizeInstrumentList(item.h,item.w);
            break;
          case 'Margin':
            this.props.resizeMargin(item.h,item.w);
            break;
          case 'Trade':
            item.name = 'Trade';
            if(item.i == this.props.trdkey){
              this.props.resizeTradePanel(item.h,item.w);
            }else{
              this.props.resizeTradePanel(item.h,item.w);
            }
            break;
          case 'TradeActivityBook':
            this.props.resizeTradebook(item.h,item.w);
            break;
          case 'Chart':
            this.props.resizeChart(item.h,item.w);
            break;
          default:
            break;
        }
      });
      this.props.setLayoutFlag(false);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setDefaultlayoutModal', component:"LayoutComponent"});
    }
  }

  closeLayoutModal = () =>{
    try{
      this.props.setLayoutFlag(false);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeLayoutModal', component:"LayoutComponent"});
    }
  }

  onClickDeleteLayout = (tempid,tempDes,tempName,isDefault)=>{
    try{
      const layout = JSON.parse(tempDes);
      this.setState({tempid: tempid});
      this.setState({tempDesc: tempDes});
      this.setState({tempName: tempName});
      this.setState({deletelayoutModal:true});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onClickDeleteLayout', component:"LayoutComponent"});
    }
  }

  deleteLayoutCnfrmBox = () => {
    try{
      this.setState({deletelayoutModal: false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'deleteLayoutCnfrmBox', component:"LayoutComponent"});
    }
  }

  ondeleteLayout = (tempid,tempName) => {
    try{
      this.props.deleteLayout(tempid,tempName,"D");
      this.setState({deletelayoutModal:false});
      this.props.loadWidgetTheme();
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'ondeleteLayout', component:"LayoutComponent"});
    }
  }

  afterOpenModal() {
    try{
      const thisComponent = this.refs.layoutPopup;
      ////const allCssStyleRules = this.props.selectedCssColorTheme;
      // const elementsData = [
      //   {"classNames":"widgetHeader", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"tempDiv", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
      //   {"classNames":"templateElmnt", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
      //   {"classNames":"templName", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
      //   {"classNames":"tmplButtons", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
      //   {"classNames":"widgetTitle", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"closeBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"lytModalbox", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
      //   {"classNames":"innerDiv", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
      //   {"classNames":"header","elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"msg","elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"popbutton","elementType":"normal", "applyTo":"all", "tagNames":"button"},
      //   {"classNames":"setDefaultBtn","elementType":"normal", "applyTo":"all", "tagNames":"span"}
      // ];
      // applyStyle(thisComponent, allCssStyleRules, elementsData);
      const directionData = [
        {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"lyoutContainer","elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"tempWrapper", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"templName", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"header", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"popbutton","elementType":"normal", "applyTo":"single", "tagNames":"button"},
        {"classNames":"cancelConfrmBtn", "elementType":"normal", "applyTo":"all", "tagNames":"div"}
      ];
      setDirection(thisComponent,directionData,this.props.selectedLang);
      const hoverElementsClassNames = [
          {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
          {"elmToHover":thisComponent.getElementsByClassName("popbutton")[0], "classNames":"popbutton"},
          {"elmToHover":thisComponent.getElementsByClassName("popbutton")[1], "classNames":"popbutton"}
      ];
      ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"LayoutComponent"});
    }
  }
  render() {
    const {templatelist,tempid,tempDesc,tempName} = this.state;
    return (
      <div id="layoutCompMain">
      <Modal isOpen={this.props.layoutModal} className={`${styles.lytModal} lytModalbox`}  id="lytModal" onAfterOpen={this.afterOpenModal} style={this.props.selectedLang.lytModalbox}>
        <div ref="layoutPopup" className="mdlWrap" >
        <div className={`${styles.widgetHeader} widgetHeader`}>
          <span className={`${styles.widgetTitle} widgetTitle`}>{i18next.t('layouts')}</span>
          <span onClick={this.closeLayoutModal} className={`${styles.closeImg} closeIcon commonCloseIcon`} id="closelayoutIcon"><MUIIconWithTooltip icon={'Close'} className="dp48 closeBtn" title={i18next.t("close")}/></span>
        </div>
        <div className={`${styles.container} lyoutContainer`}>
        {/*  <div className={styles.layoutHead}>
            <label>{i18next.t("Layouts")}</label>
          </div>*/}
        <div className={`${this.props.language} ${styles.templatesDiv}`}>
          <div className={`${styles.innerDiv} innerDiv`}>
            { this.state.templatelist && this.state.templatelist.map((templates) => {
              const tempData =JSON.parse(templates.D).tmplData;
              const layout = { lg: tempData}
            return (
              <div className={`${styles.tempDiv} tempDiv`} id="tempDivId">
                  <div className={`${styles.tempWrapper} tempWrapper`}>
                    <ResponsiveReactGridLayout  className={styles.tmplLayout} layouts={layout}  breakpoints={{lg: 1280, md: 996, sm: 768, xs: 480, xxs: 240}}
                      cols={{lg: 5, md:5, sm: 5, xs: 5, xxs:5 }}
                      gutter={{ lg: 1, md: 1, sm: 1, xs:1,xxs:1}}
                      rowHeight={40}
                      isResizable={false}
                      autoSize={true}
                      margin= {[10, 10]}>
                      {tempData.map((templates) => {
                            return(
                            <div key={templates.i} className={`${styles.templateElmnt} templateElmnt`}>
                            <span>{
                              templates.name==='Trade' ? 'TR' : templates.name==='Chart' ? 'CH' : templates.name==='Margin'? 'MR' :
                              templates.name==='InstrumentList' ? 'IL' : templates.name==='TradeActivityBook' ? 'TB' : null}
                            </span>
                            </div>
                          );
                        })
                      }
                    </ResponsiveReactGridLayout>
                </div>
                <div className={`${styles.templName} templName`}>
                {this.props.language !== 'AR' ?
                <label>{templates.N}{templates.isDef===true? <span>({i18next.t("default")})</span>:null} </label>
                :<label>{templates.isDef===true? <span>({i18next.t("default")})</span>:null}{templates.N}</label>}
                </div>
                <div className={`${styles.tmplButtons} tmplButtons`}>
                  {this.props.language !== 'AR' ?
                  <span className="loadTemplateBtn" onClick={() =>this.loadTemplate(templates.D)} id="loadTemplateBtn">{i18next.t("load")}</span>:
                    <span onClick={() =>this.onClickDeleteLayout(templates.C,templates.D,templates.N,templates.isDef)} id="deleteLayout">{i18next.t("delete")}</span>}
                  <span className="setDefaultBtn" onClick={() =>this.setDefaultlayoutModal(templates.C,templates.D,templates.N)} id="setDefaultBtn">{i18next.t("setAsDefault")}</span>
                    {this.props.language !== 'AR' ?<span onClick={() =>this.onClickDeleteLayout(templates.C,templates.D,templates.N,templates.isDef)} id="deleteLayout">{i18next.t("delete")}</span>:
                      <span className="loadTemplateBtn" onClick={() =>this.loadTemplate(templates.D)} id="loadTemplateBtn">{i18next.t("load")}</span>}</div>
                  {/*{ this.state.setDefaultlayoutModal === true ?
                    <Modal isOpen={this.state.setDefaultlayoutModal} className={styles.warningModal}>
                     <div className="mdlWrap">
                       <div className={styles.errorheader}>
                         <span className={`${styles.errormsgTitle}`}></span>
                       </div>
                       <span onClick={this.cancelAlertCnfrmBox} className={`${styles.closeImg} closeIcon`} id="cancelAlertBox"><img width="16px" src="/images/close.png"/></span>
                       <div className={styles.msgWrap}>
                         <h4>{i18next.t("Are you sure you want to set this layout as default")}?</h4>
                         <div className={`${styles.btnWrap} col-md-12`}>
                           <Button onClick={this.cancelAlertCnfrmBox} id="cancelLayoutBtn">{i18next.t("No")}</Button>&nbsp;&nbsp;
                           <Button className='button-l' onClick={() =>this.setAsDefault(tempid,tempDesc,tempName)} id="confirmLayoutBtn">{i18next.t("Yes")}</Button>
                         </div>
                       </div>
                     </div>
                   </Modal> : null
                 }*/}
                </div>
          );
          })
        }
            </div>
          </div>
         </div>
        </div>
      </Modal>
      { this.state.deletelayoutModal === true ?
        <Modal isOpen={this.state.deletelayoutModal} id="lyoutWrngModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
         <div ref="layoutPopup" className="mdlWrap" >
           <div className={`${styles.errorheader} header`}>
             <span className={`${styles.errormsgTitle}`}></span>
           </div>
           <span onClick={this.deleteLayoutCnfrmBox} className={`${styles.closeImg} closeIcon commonCloseIcon`} id="cancelDeleteAlertBox"><MUIIcon icon={'Close'} className="dp48 closeBtn"/></span>
           <div className={`${styles.msgWrap} msg commonMsgDir`}>
             <h4>{i18next.t("deleteLayoutConfrmMsg")}</h4>
          </div>
             <div className={this.props.language === 'AR'? `${styles.btnWrap} col-md-3 cancelConfrmBtn`:`${styles.btnWrap} col-md-12`}>
               <Button className='popbutton' onClick={this.deleteLayoutCnfrmBox} id="cancelDeleteLayoutBtn">{i18next.t("no")}</Button>&nbsp;&nbsp;
               <Button className='button-l popbutton' onClick={() =>this.ondeleteLayout(tempid,tempName)} id="confirmDeleteLayoutBtn">{i18next.t("yes")}</Button>
             </div>

         </div>
       </Modal> : null
     }
      </div>
    );
  }
}
